import React from "react"
import { has } from "lodash"

import { v4 as uuidv4 } from "uuid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faDownload, faTimes, faSpinner } from "@fortawesome/free-solid-svg-icons"

class EventBundleForm extends React.Component {
    constructor() {
        super()
        this.pageSize = 10
        this.state = {
            error: "",
            history: [],
            isLoading: true,
            page: 1,
            loadMore: true,
            selectedVersion: null,
            showVersionDropdown: false,
            eventBundleInfo: {},
        }
        this.versionDropDownRef = React.createRef()
    }
    componentDidMount() {
        this.getEventBundleInfo(this.state.selectedVersion);
        this.getVersionHistory(0);
        window.addEventListener("click", this.hideDropDown);
    }
    getVersionHistory = (offset) => {
        fetch(`/api/data/project/${this.props.projectId}/version/list?limit=${this.pageSize}&offset=${offset}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                var loadMore = true
                if (data.results.length < this.pageSize) {
                    loadMore = false
                }
                this.setState(prevState => {
                    return {
                        history: [...prevState.history, ...data.results.sort((a, b) => b.code - a.code)],
                        isLoading: false,
                        loadMore: loadMore
                    }
                })
            })
            .catch(data => {
                this.setState({
                    error: `Server: ${data.error}`,
                    isLoading: false
                })
            })
    }
    getEventBundleInfo = (version) => {
        if (!version) {
            return;
        }
        const platforms = this.props.appConfig.platforms.split(',');
        for (const platfrom of platforms) {
            fetch(`/assetbundles/check_event_bundle?project_id=${this.props.projectId}&game_version=${version}&target_platform=${platfrom}`)
                .then(res => res.json())
                .then(data => {
                    if (has(data, "error")) { throw data }
                    this.setState(prevState => {
                        prevState.eventBundleInfo[platfrom] = data.url;
                        return {
                            eventBundleInfo: prevState.eventBundleInfo
                        }
                    })
                })
                .catch(data => this.setState({ error: `Server: ${data.error}` }))
        }
    }
    hideDropDown = (e) => {
        if (this.state.showVersionDropdown === true && !this.versionDropDownRef.current.contains(e.target)) {
            this.setState({
                showVersionDropdown: false
            });
        }
    }
    toggleVersionDropDown = (e) => {
        this.setState(prevState => {
            return {
                showVersionDropdown: !prevState.showVersionDropdown
            }
        })
    }
    submitVersionDropDownValue = (version) => {
        this.setState({
            selectedVersion: version,
            showVersionDropdown: false
        })
        this.getEventBundleInfo(version);
    }
    loadMore = (e) => {
        this.setState(prevState => {
            return {
                page: prevState.page + 1,
                isLoading: true
            }
        }, () => this.getVersionHistory((this.state.page - 1) * this.pageSize))
        e.preventDefault()
        e.stopPropagation()
    }
    formatEventBundleInfo = (platform) => {
        if (this.state.eventBundleInfo && this.state.eventBundleInfo[platform]) {
            const url = this.state.eventBundleInfo[platform];
            return <h5 className="col success"><FontAwesomeIcon icon={faCheck} />&nbsp;<a>Success</a>&nbsp;<FontAwesomeIcon icon={faDownload} />&nbsp;<a href={url}>Download</a></h5>
        }
        return <h5 className="col canceled"><FontAwesomeIcon icon={faTimes} />&nbsp;<a>NONE</a></h5>
    }
    render() {
        const { history, loadMore, isLoading, selectedVersion, showVersionDropdown } = this.state
        const platforms = this.props.appConfig.platforms.split(',');
        return (
            <form className="requestForm">
                <div className="buildConfigForm">
                    <div className="dropdownContainer" tabIndex="0" ref={this.versionDropDownRef}
                        aria-expanded={showVersionDropdown}>
                            {history.length > 0
                                ? <div className="dropdownHeader" onClick={this.toggleVersionDropDown}>{selectedVersion === null ? "Select an version!" : `Version: ${selectedVersion}`}
                                    <title>Open drop down</title>
                                </div>
                                : <div className="dropdownHeader disabled">Publish a version in DreamEditor first!</div>}
                            <div className={`dropdownContent ${showVersionDropdown === false ? "hidden" : ""}`}>
                                <div className="normalOption" role="listbox">
                                    {history.filter((x1, i) => i === history.findIndex((x2) => x1.name === x2.name)).map((version) =>
                                        <div className="option" key={uuidv4()} aria-label={version.name} tabIndex="0" aria-hidden="true" aria-selected="false" role="option" onClick={() => this.submitVersionDropDownValue(version.name)}>
                                            {`Engine version: ${version.name}`}
                                        </div>)}
                                </div>
                                {isLoading
                                    ? <div className="loading option"><FontAwesomeIcon icon={faSpinner} spin /></div>
                                    : null}
                                {loadMore
                                    ? <div className="option" aria-hidden="true" aria-selected="false" role="option" onClick={this.loadMore} tabIndex="0">Load more... </div>
                                    : null}
                            </div>
                    </div>
                </div>
                {
                    selectedVersion &&
                        <div>
                            <div className="formWrapper">
                                <div>Event Bundle Info</div>
                                <div className="buildConfigForm">
                                    {
                                        platforms.map(p => <h5 className="col title">{p.toUpperCase()}</h5>)
                                    }
                                </div>
                                <div className="buildConfigForm">
                                    {platforms.map(platform => 
                                        this.formatEventBundleInfo(platform)
                                    )}
                                </div>
                            </div>
                        </div>
                }
            </form>
        )
    }
}

export default EventBundleForm